import { SupplyBasicFeaturePage } from "..";

/** 车队供应商页面。 */
export function BusesPage() {
  return <SupplyBasicFeaturePage kind="buses" />;
}
